import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DownloaderService {

  constructor(
    private http: HttpClient
  ) { }

  //  Method to download the files from the assets folder
  getFileFromAssets(url: string) {
    window.open(url);
  }

  // Method to get the file from any server and download in local
  getFile(filename: string, type: string) {
    this.http.get(filename, { responseType: 'arraybuffer' })
      .subscribe(response => this.downLoadFile(response, type));
  }

  /**
     * Method is use to download file.
     * @param data - Array Buffer data
     * @param type - type of the document.
     */
  private downLoadFile(data: any, type: string) {
    const blob = new Blob([data], { type: type });
    // The file gets created in the browsers memory with a random name.
    const url = window.URL.createObjectURL(blob);
    const pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed === 'undefined') {
      alert('Please disable your Pop-up blocker and try again.');
    }
    window.URL.revokeObjectURL(url);
  }
}
